<script setup>
import { onMounted, ref, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'

import { formatDate } from '@/lib/date_helper.js'
import { isCompletedStatus, isExpiredStatus } from '@/lib/job_status_helper.js'

const props = defineProps({
  quote: {
    type: Object,
    required: true,
  },
  type: {
    type: String
  }
})

const emit = defineEmits(['moveToServiceHistory'])

// Variables
const { t } = useI18n();
const isLoading = ref(true);

onMounted(async () => { });

const moveToService = () => {
  emit('moveToServiceHistory', props.quote)
}
</script>

<template>
  <RouterLink :to="props.type === 'current' ? {name: 'my_garage.quote', params: {id: quote.id}} : {name: 'all_quotes', params: {id: quote.id}} " >
    <img src="../../../assets/images/service-center-standards.jpg" class="h-[150px] w-full object-cover rounded-t-xl" />
    <div class="absolute w-full quote-header-overlay rounded-t-xl h-[150px]">
      <div class="p-4 w-full h-full">
        <div class="flex flex-col h-full">
          <p v-if="quote.created_at" class="uppercase text-xs">
            {{ t('my_garage.quote_card.requested', { date: formatDate(quote.created_at) }) }}
          </p>
          <div class="flex items-start gap-2">
            <div class="flex-shrink-0 mt-1">
              <span v-if="isCompletedStatus(quote.job_status)" class="inline-flex items-center justify-center w-4 h-4 rounded-full bg-green-100" :title="quote.job_status === 'historical' ? 'Historical' : 'Completed'">
                <svg class="w-2.5 h-2.5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                </svg>
              </span>
              <span v-else-if="isExpiredStatus(quote.job_status)" class="inline-flex items-center justify-center w-4 h-4 rounded-full bg-gray-200" :title="quote.job_status === 'stale' ? 'Stale' : 'Expired'">
                <svg class="w-2.5 h-2.5 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                </svg>
              </span>
              <span v-else class="inline-flex items-center justify-center w-4 h-4 rounded-full bg-blue-100" title="In Progress">
                <svg class="w-2.5 h-2.5 text-blue-600 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
            </div>
            <p class="font-semibold text-xl line-clamp-3 my-auto flex-1">
              {{ quote.service_title }}
            </p>
          </div>
          <div class="grow"></div>
          <p v-if="quote.user_vehicle" class="line-clamp-1 my-auto">
            {{ quote.user_vehicle.full_vehicle_name }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="border-b p-4">
        <p v-if="quote.description" class="line-clamp-6 my-auto">
          {{ quote.description }}
        </p>
        <p v-if="quote.user_vehicle_service_histories && quote.user_vehicle_service_histories[0] && quote.user_vehicle_service_histories[0].status === 'cancelled'" class="font-semibold pt-2">{{ t('my_garage.quote_card.cancelled') }}</p>
        <p v-else-if="quote.expires_at">{{ t('my_garage.quote_card.expires', { date: formatDate(quote.expires_at) }) }}</p>
        <p v-else class="font-semibold pt-2">{{ t('my_garage.quote_card.incomplete') }}</p>
      </div>
      <div class="flex flex-row justify-between py-3 px-4">
        <p class="generic-text-button" @click.prevent="moveToService">{{ t('my_garage.quote_card.move_to_service') }}</p>
        <!-- <img src="../../../assets/icons/more_horiz_24dp_FILL0_wght400_GRAD0_opsz24.svg"> -->
      </div>
    </div>
  </RouterLink>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/views/my_garage/my_garage';
</style>
